import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "message"];

  declare buttonTarget: HTMLButtonElement;
  declare messageTarget: HTMLElement;

  sync(event: Event) {
    event.preventDefault();

    const form = this.buttonTarget.closest("form") as HTMLFormElement;
    const formData = new FormData(form);

    // Disable button and show loading state
    this.buttonTarget.disabled = true;
    this.buttonTarget.classList.remove("hover:bg-blue-600");
    this.buttonTarget.classList.add("cursor-not-allowed");

    fetch(form.action, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token":
          (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)
            ?.content || "",
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          // Show success message
          this.messageTarget.innerHTML = `
          <div class="p-4 bg-green-100 text-green-800 rounded-lg text-sm shadow-sm mt-2">
            ✅ Photos syncing, this may take a few minutes!
          </div>
        `;
          this.messageTarget.style.display = "block";
        } else {
          throw new Error("Network response was not ok");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Re-enable button on error
        this.buttonTarget.disabled = false;
        this.buttonTarget.classList.add("hover:bg-blue-600");
        this.buttonTarget.classList.remove("bg-gray-400", "cursor-not-allowed");

        // Show error message
        this.messageTarget.innerHTML = `
        <div class="p-4 bg-red-100 text-red-800 rounded-lg text-sm shadow-sm mt-2">
          ❌ Error syncing photos. Please contact software support.
        </div>
      `;
        this.messageTarget.style.display = "block";
      });
  }
}
